module.exports = __webpack_public_path__ + "img/img_family_02.3ea7f9fb.svg";